import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/auth";

export function UpdatePasswordPage() {
  const { updatePassword, error } = useAuth();
  const [pass1, setPass1] = useState("");
  const [pass2, setPass2] = useState("");
  const [done, setDone] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (pass1 !== pass2) return alert("Passwords do not match");
    setSubmitting(true);
    try {
      await updatePassword(pass1);
      setDone(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="max-w-sm mx-auto mt-16 p-4 rounded border bg-card">
      <h1 className="text-lg font-semibold mb-3">Set new password</h1>
      <form onSubmit={onSubmit} className="space-y-3">
        <div className="grid gap-1">
          <Label htmlFor="p1">New password</Label>
          <Input id="p1" type="password" autoComplete="new-password" value={pass1} onChange={e => setPass1(e.target.value)} required />
        </div>
        <div className="grid gap-1">
          <Label htmlFor="p2">Confirm password</Label>
          <Input id="p2" type="password" autoComplete="new-password" value={pass2} onChange={e => setPass2(e.target.value)} required />
        </div>
        {error && (
          <div className="text-sm text-destructive">
            {import.meta.env.DEV ? error : "Something went wrong. Please try again."}
          </div>
        )}
        <Button type="submit" disabled={submitting}>{submitting ? "Updating…" : "Update password"}</Button>
      </form>
      {done && <div className="text-sm text-emerald-600 mt-2">Password updated. You can close this tab.</div>}
    </div>
  );
}

export default UpdatePasswordPage;
